import { Box, Stack, Typography } from "@mui/material"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { temperaturePillSx } from "./DoorTemperaturePill"
import { formatTemperatureValue, WARN_COLOR } from "./temperatureDemoFormat"
import type { TemperatureLevel } from "./temperatureDemoGenerator"

const SAMPLES: { level: TemperatureLevel; value: number; labelKey: string }[] = [
  { level: "ok", value: 4.6, labelKey: "temperatureDemo.legendNormal" },
  { level: "warn", value: 8.7, labelKey: "temperatureDemo.legendWarning" },
  { level: "crit", value: 11.6, labelKey: "temperatureDemo.legendCritical" },
]

/** LOCKER-534 — key under the door grid of a demo-enabled locker. */
export const TemperatureDemoLegend: FC = () => {
  const { t, i18n } = useTranslation()
  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      alignItems="center"
      columnGap={2}
      rowGap={1.25}
      sx={{ fontSize: 12, color: "text.secondary", mx: 2, mt: 1 }}
    >
      <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#374151" }}>
        {t("temperatureDemo.legendTitle")}
      </Typography>
      {SAMPLES.map((s) => (
        <Stack key={s.level} direction="row" alignItems="center" spacing={0.75}>
          <Box component="span" aria-hidden sx={temperaturePillSx(s.level)}>
            {`${formatTemperatureValue(s.value, i18n.language)} °C`}
          </Box>
          <span>{t(s.labelKey)}</span>
        </Stack>
      ))}
      <Stack direction="row" alignItems="center" spacing={0.75}>
        <Box
          component="span"
          aria-hidden
          sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: WARN_COLOR }}
        />
        <span>{t("temperatureDemo.legendPastBreach")}</span>
      </Stack>
    </Stack>
  )
}
